<template>
    <v-container>
        <v-card class="cardSide" :loading="loading">
            <v-card-text style="height: 92%;">
                <v-row style="height: 100%;">
                    <!-- <v-col cols ="5" style="height: 100%;">
                        <v-form ref="form">
                            <v-card-title>
                                <span class="headline">{{ 'Cadastro de Idiomas' | translate('Idiomas')}} </span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-row class="rowPadding">
                                    <v-col style="padding: 0em 3em;">
                                        <v-text-field
                                            autofocus
                                            :loading="loading"
                                            v-model="editedItem.DESCRICAO"
                                            :label="labels.description"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="rowPadding">
                                    <v-col style="padding: 0em 3em;">
                                        <v-text-field
                                            autofocus
                                            :loading="loading"
                                            v-model="editedItem.SIGLA"
                                            :label="labels.sigla"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn
                                    class="btn1"
                                    dark
                                    @click="save"
                                > 
                                    <v-icon x-small>
                                        mdi-check
                                    </v-icon>
                                    <span style="margin-left: 4px;">{{'Salvar' | translate('Idiomas')}}</span>
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-col>
                    <v-divider vertical inset /> -->
                    <v-col style="height: 100%;">
                        <v-card-title>
                            <v-row>
                                <v-col cols="7" style="padding-left:3em;">
                                    <span class="headline">{{ labels.description }} </span>
                                </v-col>
                                <v-col cols="3">
                                    <span class="headline">{{ labels.sigla }} </span>
                                </v-col>
                                <v-col cols="2">
                                    <span class="headline">{{ 'Ativo' | translate('Idiomas')}} </span>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-list two-line class="scrollList">
                            <template v-for="(item, index) in languages">
                                <v-list-item @click.stop class="py-0 dragItem" :key="item.ID" ref="item">
                                    <v-row style="align-items: center; border-bottom: 1px solid #dddddd;">
                                        <v-col style="display: contents; height:30px;" cols="7">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="px-3"
                                                    v-text="item.DESCRICAO"
                                                ></v-list-item-title>
                                            </v-list-item-content>
                                        </v-col>
                                        <v-col style="display: contents; height:30px;" cols="3">
                                            <v-list-item-content style="text-align: center;">
                                                <v-list-item-title
                                                    class="px-3"
                                                    v-text="item.SIGLA"
                                                ></v-list-item-title>
                                            </v-list-item-content>
                                        </v-col>
                                        <v-col style="padding:0;" cols="2">
                                            <v-list-item-action>
                                                <v-switch
                                                    v-model="item.ATIVO"
                                                    true-value="S"
                                                    false-value="N"
                                                    color="black"
                                                    :id="index.toString()"
                                                    @change="update(item)"
                                                    inset
                                                ></v-switch>
                                            </v-list-item-action>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import getAllLanguages from '../../../../src/app/idioma/getAllLanguages'
import { createNamespacedHelpers } from 'vuex'
import translate from '../../../../src/plugins/translate'
import addLanguage from '../../../../src/app/idioma/insertLanguage'
import removeFactoryLanguage from '../../../../src/app/empresa_idioma/removeFactoryLanguage'
import insertFactoryLanguage from '../../../../src/app/empresa_idioma/insertFactoryLanguage'

const user = createNamespacedHelpers('user')

export default {
    name: 'Idiomas',
    data() {
        return {
            loading: false,
            editedItem: {},
            languages: [],
            labels: {
                description: translate('Descrição', 'Idiomas'),
                sigla: translate('Sigla', 'Idiomas')
            },
        }
    },
    methods: {
        async getLanguages(){
            this.loading = true
            await getAllLanguages('', this.user.EMPRESA_ID)
                .then(function(response){
                    this.languages = response.data
                }.bind(this))
                .then(this.loading = false)
        },
        calcel() {
            this.editedItem = {}
        },
        async save(){
            this.loading = true
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            await addLanguage(this.editedItem)
                .then(function(){
                    this.getLanguages()
                }.bind(this))
                .finally(this.loading = false, this.cancel())

        },
        invalidUpdate(){
            var actives = 0
            for(var i = 0; i < this.languages.length; i++) if(this.languages[i].ATIVO == 'S') actives++
            return actives > 3
        },
        async update(language){
            if(this.invalidUpdate()){
                this.$nextTick(function(){
                    language.ATIVO = 'N'
                })
                this.$notify.warning({
                    title: translate('Atenção' , 'Idiomas'),
                    message: translate('É possível manter ativos somente três idiomas.', 'Idiomas')
                });
                return
            }
            this.loading = true
            language.EMPRESA_ID = this.user.EMPRESA_ID
            if(language.ATIVO == 'N') await removeFactoryLanguage(language.EMPRESA_IDIOMA_ID)
                .then(function(){
                    this.getLanguages()
                }.bind(this))
                .finally(this.loading = false)
            else await insertFactoryLanguage(language)
                .then(function(){
                    this.getLanguages()
                }.bind(this))
                .finally(this.loading = false)
        }

    },
    computed:{
        ...user.mapGetters(['user'])
    },
    async mounted() {
        await this.getLanguages()
    },

}
</script>
<style scoped>
.btn1{
    text-transform: none !important;
}
.headerPage{
    height: 2rem;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.headline{
    font-size: 14px !important;
}
.rowPadding{
    justify-content: center;
}
.scrollList{
    overflow-y: auto;
    overflow-x: hidden;
    height: 84%;
    max-height: 84%;
}
.scrollList::-webkit-scrollbar {
    width: 8px;
}

.scrollList::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.scrollList::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.cardSide{
    height: 560px;
}
</style>
